import { __rest } from "tslib";
import * as React from 'react';
import toArray from 'rc-util/lib/Children/toArray';
import warning from '../../_util/warning';
function filter(items) {
    return items.filter((item) => item);
}
export default function useLegacyItems(items, children) {
    if (items) {
        return items;
    }
    warning(!children, 'Tabs', 'Tabs.TabPane is deprecated. Please use `items` directly.');
    const childrenItems = toArray(children).map((node) => {
        if (React.isValidElement(node)) {
            const { key, props } = node;
            const _a = props || {}, { tab } = _a, restProps = __rest(_a, ["tab"]);
            const item = Object.assign(Object.assign({ key: String(key) }, restProps), { label: tab });
            return item;
        }
        return null;
    });
    return filter(childrenItems);
}
